<template>
  <div class="city-box">
    <div class="city-base">
      <div class="item" @click="changePage">
        <img src="@/assets/imgs/center/1.png" />
        <div class="info">
          <div class="title">生产主体</div>
          <div class="value">{{ mainBodyCount && mainBodyCount.sc || 0 }}</div>
        </div>
      </div>
      <div class="item" @click="changePage">
        <img src="@/assets/imgs/center/2.png" />
        <div class="info">
          <div class="title">屠宰主体</div>
          <div class="value">{{ mainBodyCount && mainBodyCount.tz || 0 }}</div>
        </div>
      </div>
      <div class="item" @click="changePage">
        <img src="@/assets/imgs/center/3.png" />
        <div class="info">
          <div class="title">加工主体</div>
          <div class="value">{{ mainBodyCount && mainBodyCount.jg || 0 }}</div>
        </div>
      </div>
    </div>
    <div id="myChart" class="map-box" @click="changeCity">
      <div v-for="(marker, index) in locationMarkers" :key="index" class="location-marker"
        :style="{ left: marker.x + 'px', top: marker.y + 'px' }">
        <img src="@/assets/imgs/location.png" alt="位置标记" />
      </div>
    </div>
    <div class="template-box">
      <div class="item">
        <img src="@/assets/imgs/fwz-icon.png" />
        <span>乡镇速测室</span>
      </div>
      <div class="item">
        <img src="@/assets/imgs/jcs-icon.png" />
        <span>合格证服务站</span>
      </div>
    </div>
  </div>
</template>
<script>
import cityJSON from "@/assets/city.json";
import "echarts-gl";
import * as echarts from "echarts";
import { getAreCodeByName } from "@/utils/other"
import { request_get } from "@/utils/request"
export default {
  name: "City",
  data() {
    return {
      myChart: null,
      currentInfo: {},
      mainBodyCount: {},
      cityInfoList: [],
      locationMarkers: [], // 存储位置标记的数组
      savedMapState: null, // 保存地图状态
      currentDeletion: {}
    };
  },
  watch: {
    currentInfo: {
      handler(val) {
        this.getMainBodyCount()
      },
      deep: true
    }
  },
  props: {
    oldLocation: {
      type: Array,
      default: () => []
    },
    deletion: {
      type: Object,
      default: () => { }
    }
  },
  watch: {
    oldLocation: {
      handler(val) {
        this.locationMarkers = val
      },
      deep: true
    },
    deletion: {
      handler(val) {
        this.currentDeletion = val
        this.initMyChart1(cityJSON, this.cityData);
      },
      deep: true
    }
  },
  async mounted() {
    this.locationMarkers = this.oldLocation
    this.currentDeletion = this.deletion
    await this.initMyChart1(cityJSON, this.cityData);
    // 先初始化地图
    if (Object.keys(this.currentDeletion).length > 0) {

    }

    // 如果有保存的状态，恢复它
    if (this.savedMapState) {
      this.restoreMapState()
    } else {
      // 如果没有保存的状态，获取初始数据
      await this.getMainBodyCount()
      this.getAreaInfo()
    }

    // 添加窗口大小变化监听，确保地图和标记位置正确
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    // 在组件销毁前保存地图状态
    this.saveMapState()
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    // 在组件销毁前保存地图状态
    this.saveMapState()
  },
  methods: {
    changePage() {
      this.$emit("changePage")
    },
    changeCity(ev) {
      let geoPt = this.myChart.convertFromPixel('geo', [ev.offsetX, ev.offsetY])
      const point = turf.point(geoPt);
      const features = cityJSON.features;
      const hitFeature = features.find(f => turf.booleanPointInPolygon(point, f))
      if (!hitFeature) {
        this.currentInfo = {
          name: "",
          code: "",
        };
        this.$emit("changeLocation", [])
        this.$emit("getCode", this.currentInfo)
      }
      // if (!pt) {
      //   // 转换失败，肯定点在外面
      //   handleOutside();
      //   return;
      // }
      // this.currentInfo = {
      //   name: "",
      //   code: "",
      // };
      // this.$emit("changeLocation", [])
      // this.myChart.dispatchAction({ type: 'mapUnSelect', seriesIndex: 0 });
      //     // 保存当前地图状态
      //     this.saveMapState();
      //     // setTimeout(() => lastTrigger = null, 300);
      // console.log(e, 222)
    },
    async changeMap() {
      // 如果地图已经初始化，不需要重新初始化
      if (!this.myChart) {
        await this.initMyChart1(cityJSON, this.cityData);
      }

      // 确保定位标记在地图上显示
      if (this.locationMarkers && this.locationMarkers.length > 0) {
        // 强制更新视图以确保标记显示
        this.$forceUpdate();
      }
    },
    // 保存地图状态
    saveMapState() {
      if (this.myChart) {
        this.savedMapState = {
          currentInfo: JSON.parse(JSON.stringify(this.currentInfo)),
          locationMarkers: JSON.parse(JSON.stringify(this.locationMarkers))
        }
      }
    },

    // 恢复地图状态
    restoreMapState() {
      if (this.savedMapState && this.myChart) {
        // 恢复当前选中的区域信息
        this.currentInfo = this.savedMapState.currentInfo

        // 恢复位置标记
        this.locationMarkers = this.savedMapState.locationMarkers

        // 如果有选中的区域，触发相应的地图事件
        if (this.currentInfo && this.currentInfo.name) {
          this.$emit("getCode", this.currentInfo)

          // 获取主体数据统计
          this.getMainBodyCount()

          // 在地图上显示选中效果
          if (this.myChart) {
            this.myChart.dispatchAction({
              type: 'mapSelect',
              name: this.currentInfo.name
            })
          }
        }
      }
    },

    // 获取地区的信息
    getAreaInfo(params) {
      request_get("/lsd/index/areaCount", { area: "" }, res => {
        if (res.code == 200) {
          this.cityInfoList = res.data || []
        }
      })
    },
    // 主题数据统计
    getMainBodyCount() {
      request_get("/lsd/index/mainBodyCount", { area: this.currentInfo?.name || "" }, res => {
        if (res.code == 200) {
          this.mainBodyCount = res.data;
        }
      })
    },
    initMyChart1(jsonData, data) {

      let that = this;
      const domImg = require('@/assets/bg-map.png');
      let lastTrigger = { type: null, time: 0 };
      // if (this.myChart) this.myChart.dispose();
      echarts.registerMap("gy", jsonData);
      const myChart = echarts.init(document.getElementById("myChart"));
      // 阴影边框颜色数组（分层）
      const borderColors = ["#0099cc", "#006699"];

      // 生成阴影层
      const shadowGeoLayers = borderColors.map((color, i) => ({
        type: "map",
        map: "gy",
        geoIndex: i + 1,
        silent: true, // 阴影层不要触发交互
        zlevel: -(i + 1),
        zoom: 1.12,
        layoutCenter: ["50%", "50%"],
        layoutSize: "100%",
        // itemStyle: {
        //   areaColor: "#fff", // 阴影层底色
        //   shadowBlur: 10,
        //   shadowColor: color,
        //   shadowOffsetX: 10,
        //   shadowOffsetY: 20,
        //   opacity: 0.5,
        //   color:"#fff",
        //   borderColor: "transparent",
        // },
        itemStyle: {
          normal: {
            areaColor: {
              type: "pattern",
              image: domImg, //配置图片
              repeat: "repeat", //可选值repeat、no-repeat、repeat-x、repeat-y
            },
            shadowColor: "rgba(45,93,124,1)",              // areaColor: "#386B9A", // 主地图颜色
            shadowOffsetX: 10,
            shadowOffsetY: 20,
            opacity: 1,
            borderColor: "rgba(45,93,124,1)",
            borderWidth: 2,
          }
        },
        emphasis: {
          itemStyle: {
            color: "#fff",
            borderColor: "transparent",
            areaColor: "#fff",
          }
        }
      }));

      const option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove|click", // 同时支持鼠标移入和点击触发
          axisPointer: { type: "none" },
          backgroundColor: "transparent", // 背景透明
          borderWidth: 0, // 去掉边框
          extraCssText: "box-shadow:none;padding:0;",
          formatter: function (params, tick, tick1) {
            let items = getAreCodeByName(params.name)
            let adcode = null;
            // 只在点击事件时执行状态保存和事件发送

            if (lastTrigger == 'click' && items.length) {
              adcode = items[0].properties.adcode;
              if (that.currentInfo.code == adcode) {
                that.currentInfo = {
                  name: "",
                  code: "",
                };
                that.$emit("changeLocation", [])
              } else {
                that.currentInfo = {
                  name: params.name,
                  code: adcode,
                };
              }

              that.$emit("getCode", that.currentInfo)

              // 保存当前地图状态
              that.saveMapState();
            } else if (items.length) {
              // 鼠标移入时只获取adcode，不改变状态
              adcode = items[0].properties.adcode;
            }

            let info = that.cityInfoList.filter(ele => ele.area == params.name)
            if (info.length) {
              info = info[0]
            }
            return `<div class="tooltip-box big" >
                            <div class="tooltip-header" style="margin-top:15px"><div>${params.name}</div></div>
                            <div class="tooltip-content">
                                <div class="tooltip-item" style="width:50%">
                                <span>监管机构数量</span>
                                <span class="text">${info.allOrgan || 0}</span>
                            </div>
                            <div class="tooltip-item" style="width:50%">
                                <span>巡查人员数量</span>
                                <span class="text">${info.inspection || 0}</span>
                            </div>
                            <div class="tooltip-item" style="width:50%">
                                <span>协管人员数量</span>
                                <span class="text">${info.assist || 0}</span>
                            </div>
                            <div class="tooltip-item" style="width:50%">
                                <span>信息员数量</span>
                                <span class="text">${info.information || 0}</span>
                            </div>
                            <div class="tooltip-item" style="width:50%">
                                <span>主体数量</span>
                                <span class="text">${info.allEntity || 0}</span>
                            </div>
                              </div>
                        </div>`;
          },
        },
        geo: [
          {
            map: "gy",
            roam: false,
            zoom: 1.12,
            layoutCenter: ["50%", "50%"],
            layoutSize: "100%",
            // selectedMode:"single",

            label: {
              show: true,
              fontSize: 22,
              fontWeight: "bold",
              color: "#fff",
            },
            itemStyle: {
              normal: {
                areaColor: {
                  type: "pattern",
                  image: domImg, //配置图片
                  repeat: "repeat", //可选值repeat、no-repeat、repeat-x、repeat-y
                },
                // areaColor: "#386B9A", // 主地图颜色
                borderColor: "rgba(45,93,124,1)",
                borderWidth: 2,
              }
            },
            select: {
              itemStyle: {
                areaColor: "rgba(0,0,0,0)",
                // areaColor: {
                //   type: "linear",
                //   x: 0,
                //   y: 0,
                //   x2: 1,
                //   y2: 1,
                //   colorStops: [
                //     { offset: 0, color: "rgba(11,183,188,1)" },
                //     { offset: 1, color: "rgba(7,113,120,1)" },
                //   ],
                // },
              }
            },
            emphasis: {
              itemStyle: {
                areaColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "rgba(11,183,188,1)" },
                    { offset: 1, color: "rgba(7,113,120,1)" },
                  ],
                },
              },
            },
          },
        ],
        series: [
          // 阴影层
          ...shadowGeoLayers,
          // 主地图层
          {
            type: "map",
            map: "gy",
            geoIndex: 0,
            selectedMode: false,
            coordinateSystem: "geo",
            zlevel: 1,
            roam: false,
            silent: true,

            // itemStyle: {
            //   borderWidth: 0,
            //   borderColor: "transparent",
            //   areaColor: "rgba(0,0,0,0)",
            // },
            itemStyle: {
              normal: {
                areaColor: {
                  type: "pattern",
                  image: domImg, //配置图片
                  repeat: "repeat", //可选值repeat、no-repeat、repeat-x、repeat-y
                },
                // areaColor: "#386B9A", // 主地图颜色
                borderColor: "rgba(45,93,124,1)",
                borderWidth: 2,
              }
            },
            select: {
              itemStyle: {
                // areaColor: "rgba(0,0,0,0)",
                areaColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "rgba(11,183,188,1)" },
                    { offset: 1, color: "rgba(7,113,120,1)" },
                  ],
                },
              }
            },
            emphasis: {
              itemStyle: {
                areaColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "rgba(11,183,188,1)" },
                    { offset: 1, color: "rgba(7,113,120,1)" },
                  ],
                },
              },
            },
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            data: that.currentDeletion.jcs ? that.currentDeletion.jcs.map(item => ({
              name: item.name, // Name of the point
              value: [+item.longitude, +item.latitude], // [longitude, latitude]
            })) : [],

            symbol: "image://https://system.nmjhuhhot.com/imgs/jcs.png",
            symbolSize: [32, 81], // Adjust the size of the point
            symbolKeepAspect: true,
            rippleEffect: {
              number: 0,
              scale: 1
            },
            itemStyle: {

            },
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            data: that.currentDeletion.fwz ? that.currentDeletion.fwz.map(item => ({
              name: item.name, // Name of the point
              value: [+item.longitude, +item.latitude], // [longitude, latitude]
            })) : [],
            geoIndex: 0,
            // symbol: 'image://./assets/marker.png',
            symbol: "image://https://system.nmjhuhhot.com/imgs/fwz.png",
            symbolSize: [32, 81], // Adjust the size of the point
            symbolKeepAspect: true,
            rippleEffect: {
              number: 0,
              scale: 1
            },
            itemStyle: {

            },
          },
        ],
      };

      myChart.setOption(option);
      this.myChart = myChart;

      // 添加点击事件监听器，实现点击后添加定位图片
      myChart.on('mousemove', params => {
        lastTrigger = 'mousemove';
        // 清除标志，避免长期保留
        setTimeout(() => lastTrigger = null, 300);
      });
      myChart.on('click', (params) => {
        // 获取点击的像素坐标
        if (params.componentSubType == "map") {
          lastTrigger = 'click';
          // 清除之前的所有标记
          this.locationMarkers = [];
          // 添加新的标记
          this.locationMarkers.push({
            x: params.event.offsetX - 16, // 调整位置使图标居中
            y: params.event.offsetY - 32  // 调整位置使图标底部对准点击位置
          });
          that.$emit("changeLocation", this.locationMarkers)

          // 重置地图样式，移除选中效果
          myChart.dispatchAction({ type: 'mapUnSelect', seriesIndex: 0 });
          // 保存当前地图状态
          this.saveMapState();
          setTimeout(() => lastTrigger = null, 300);
        } else {
          console.log(params)
        }

      });
    },

    // 处理窗口大小变化
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
        // 如果有定位标记，可能需要重新调整位置
        if (this.locationMarkers && this.locationMarkers.length > 0) {
          // 强制更新视图以确保标记显示在正确位置
          this.$forceUpdate();
        }
      }
    },
    initMyChart(jsonData, data) {
      if (this.myChart) this.myChart.dispose();

      echarts.registerMap("gy", jsonData);
      const myChart = echarts.init(document.getElementById("myChart"));

      // 阶梯边框颜色数组（白 -> 浅蓝 -> 深蓝）
      const borderColors = [
        // "#ffffff",
        // "#e6f7ff",
        // "#b3ecff",
        // "#80dfff",
        // "#4dd2ff",
        // "#1ac6ff",
        "#0099cc",
        // "#006699",
      ];

      const shadowGeoLayers = borderColors.map((color, i) => ({
        type: "map",
        map: "gy",
        roam: false,
        silent: false,
        geoIndex: i,
        zoom: 1.12,
        layoutCenter: ["50%", "50%"],
        layoutSize: "100%",
        zlevel: -i - 1, // 每层往下叠加
        itemStyle: {
          // areaColor:color,
          areaColor: "#fff",
          // areaColor:"#386B9A",
          borderColor: "transparent",
          borderWidth: 0,
          shadowBlur: 1,
          shadowColor: "#0A2C46",
          // shadowColor: "rgba(255, 255, 255, 0.1)",
          shadowOffsetY: 20,
          shadowOffsetX: 10,
          opacity: 0.9,
        },
        tooltip: {
          trigger: "item",
          triggerOn: "click",
          show: true,
          formatter: function (params) {
            console.log(params);
            return params.name;
          },
        },
      }));
      const option = {
        geo: {
          map: "gy",
          roam: false,
          zoom: 1.12,
          zlevel: 1,
          layoutCenter: ["50%", "50%"],
          layoutSize: "100%",

          label: {
            show: true,
            textStyle: {
              fontSize: 22,
              opacity: 1,
              fontWeight: "bold",
              borderWidth: 0,
              color: "white",
            },
          },
          tooltip: {
            show: true,
            trigger: "item",
            formatter: function (params) {
              console.log(params);
              return params.name;
            },
          },
          itemStyle: {
            areaColor: "#386B9A", // 主体蓝色
            borderColor: "RGBA(45, 93, 124, 1)", // 金色描边
            borderWidth: 2,
            shadowOffsetY: 0,
            opacity: 1,
          },
          emphasis: {
            itemStyle: {
              areaColor: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "RGBA(11, 183, 188, 1)",
                  },
                  {
                    offset: 1,
                    color: "RGBA(7, 113, 120, 1)",
                  },
                ],
                global: false,
              },
            },
          },
        },

        series: [
          // 阶梯立体边框层
          ...shadowGeoLayers,

          // 主地图层 + 渐变文字
          {
            type: "map",
            map: "gy",
            geoIndex: 0,
            coordinateSystem: "geo",
            zlevel: 3,
            opacity: 1,
            roam: false,
            tooltip: {
              trigger: "item",
              triggerOn: "click",
              show: true,
              formatter: function (params) {
                console.log(params, 123);
                return params.name;
              },
            },
            itemStyle: {
              borderWidth: 0,
              borderColor: "transparent",
            }, // 透明，避免覆盖 geo 主层
            emphasis: {
              itemStyle: {
                areaColor: "rgba(116,188,219,0.3)", // hover 时给个颜色，不然不明显
              },
            },
          },
        ],
      };

      myChart.setOption(option);
      this.myChart = myChart;
    },

    initMyChart2(jsonData, data) {
      if (this.myChart) {
        this.myChart.dispose();
      }
      echarts.registerMap("gy", jsonData);
      const myChart = echarts.init(document.getElementById("myChart")); // 初始化图表
      const option = {
        geo: {
          geoIndex: 0,
          map: "gy",
          zoom: 1,
          viewControl: {
            distance: 225,
            rotateSensitivity: 0, //禁止旋转
            zoomSensitivity: 0, //禁止缩放
          },
          layoutCenter: ["50%", "50%"],
          height: 800,
          width: "100%",
          boxHeight: 800,
          shading: "color",
          itemStyle: {
            areaColor: "rgba(255, 255, 255, 1)",
            borderColor: "rgba(234, 203, 169, 1)",
            borderWidth: 1,
            shadowColor: "RGBA(0, 0, 0, 0.03)",
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 20,
          },
          emphasis: {
            show: true,
            itemStyle: {
              rich: {
                gradient: {
                  fontSize: 22,
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    { offset: 0, color: "#ff7e5f" },
                    { offset: 1, color: "red" },
                  ]),
                },
              },
              areaColor: "red",
              opacity: 1,
            },
            label: {
              show: false,
              textStyle: {
                fontSize: 10,
                opacity: 1,
                borderWidth: 0,
              },
            },
          },
        },
        series: [
          {
            type: "map",
            map: "gy",
            coordinateSystem: "geo",
            zoom: 1,
            zlevel: 1,
            height: 800,
            width: "100%",
            boxHeight: 800,
            layoutCenter: ["50%", "50%"],
            label: {
              show: true,
              formatter: function ({ name }) {
                // 用 rich 里的 gradient 样式
                return `{gradient|${name}}`;
              },
              rich: {
                gradient: {
                  fontSize: 22,
                  fontWeight: "bold",
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    { offset: 0, color: "#ff7e5f" },
                    { offset: 1, color: "red" },
                  ]),
                },
              },
              //   emphasis: {
              //     show: true,
              //     formatter: function ({ name }) {
              //       return `{gradient|${name}}`;
              //     },
              //     rich: {
              //       gradient: {
              //         fontSize: 22,
              //         fontWeight: "bold",
              //         color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              //           { offset: 0, color: "#00c6ff" },
              //           { offset: 1, color: "#0072ff" },
              //         ]),
              //       },
              //     },
              //   },
            },
            itemStyle: {
              areaColor: "rgba(155, 215, 232, 0.60)",
              borderColor: "rgba(155, 215, 232, 0.60)",
              borderWidth: 0,
            },
            // emphasis: {
            //   itemStyle: {
            //     areaColor: "RGBA(211, 164, 62, 1)",
            //     opacity: 1,
            //   },
            // },
          },
        ],
      };
      myChart.setOption(option);
      this.myChart = myChart;
    },
  },
};
</script>
<style lang="scss" scoped>
.city-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .template-box {
    position: absolute;
    left: 20px;
    bottom: 100px;
    width: 195px;
    height: 134px;
    padding: 20px;
    ;
    background: linear-gradient(90deg, rgba(0, 20, 28, .5) 0%, rgba(1, 32, 45, .5) 50%, rgba(0, 20, 28, .5) 100%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-content: space-around;

    .item {
      display: flex;
      align-items: center;

      &:last-of-type {
        margin-top: auto;
      }

      img {
        width: 32px;
        height: 32px;
      }

      span {
        color: white;
        margin-left: 15px;
      }
    }
  }

  .city-base {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding: 0 20px;
    box-sizing: border-box;

    .item {
      display: flex;
      align-items: center;

      img {
        width: 85px;
        height: 75px;
        margin-right: 12px;
      }

      .info {
        display: flex;
        flex-direction: column;

        .title {
          color: rgba(221, 253, 255, 1);
          font-size: 16px;
          font-weight: 400;
        }

        .value {
          color: rgba(255, 255, 255, 1);
          font-weight: 400;
          font-size: 24px;
        }
      }
    }
  }

  .map-box {
    flex: 1;
    width: 100%;
    position: relative;

    .location-marker {
      position: absolute;
      z-index: 10;
      pointer-events: none; // 防止标记阻止地图点击

      img {
        width: 32px;
        height: 32px;
        //animation: bounce 1s infinite alternate; // 添加弹跳动画
      }
    }
  }
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-10px);
  }
}
</style>
